import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";
import api from "../../utils/axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, removeChar, hasPermission, showDBDate, validatedDate } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import { apiUrl, downloadUrl } from "../Settings/Config";
const module = "vesselposition";
const modulePath = "/vesselposition";
const moduleName = "Vessel Position";
const moduleID = 31;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        vesselID: "",
        currentPosition: "",
        nextArrivalPort: "",
        nextArrivalDate: "",
        ETD:"",
      },
      detaildata: [],
      portList: [],
      vessleList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const vesselStatus = result.vesselStatus === "A" ? "Active" : "In Active";
          const status =
            result.vesselStatus !== "" && result.vesselStatus !== null
              ? {
                  label: vesselStatus,
                  value: result.vesselStatus,
                }
              : "";
          /* const rpsl = result?.rpsl ?? "No"; */
          const currentPosition = result?.currentPosition || '';
          const clientupdatedata = {
            vesselID: result.vesselID !== "" && result.vesselID !== null ? { label: result.vesselName, value: result.vesselID } : "",
            currentPosition: currentPosition !== "" && currentPosition !== null ? { label: currentPosition, value: currentPosition } : "",
            nextArrivalPort: result.nextArrivalPort !== "" && result.nextArrivalPort !== null ? { label: result.portName, value: result.nextArrivalPort } : "",
            nextArrivalDate: validatedDate(result.nextArrivalDate),
            ETD: validatedDate(result.ETD)            
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadDropdown() {
    api
      .get("port/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ portList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vessel/activedropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vessleList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      vesselID: postData.vesselID?.value ?? "",
      currentPosition: postData.currentPosition?.value,
      nextArrivalDate: showDBDate(postData.nextArrivalDate),
      nextArrivalPort: postData.nextArrivalPort?.value ?? "",
      ETD: showDBDate(postData.ETD),
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            portList={this.state.portList}
                            vessleList={this.state.vessleList}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

export const isSingleSelectPort = function (value, currentPosition) {
  const currentPosition_ = currentPosition?.value || '';
  if (value !== undefined) {
    if(currentPosition_==='AT SEA') {
      if (value !== null && value !== "") {
        return Object.keys(value).length > 0 ? null : "This field is required.";
      } else {
        return "This field is required.";
      }
    }else {
      return null;
    }
  }
};

export const isEmptyDate = function (value, currentPosition) {
  const currentPosition_ = currentPosition?.value || '';
  if(currentPosition_==='AT SEA') {
    return value === "" ? "This field is required." : null;
  }else {
    return null;
  }
};

function validationConfig(props) {
  const { vesselID, currentPosition, nextArrivalPort, nextArrivalDate, ETD } = props.fields;

  return {
    fields: ["vesselID", "currentPosition", "nextArrivalPort", "nextArrivalDate", "ETD"],
    validations: {
      vesselID: [[isSingleSelect, vesselID]],
      currentPosition: [[isEmpty, currentPosition]],
      nextArrivalPort: [[isSingleSelectPort, nextArrivalPort, currentPosition]],
      nextArrivalDate: [[isEmptyDate, nextArrivalDate, currentPosition]],
      ETD: [[isEmpty, ETD, currentPosition]],      
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slectedPDF: "",
    };
  }
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    console.log(name, value, 'fdsfsfsfsfsfsfs')
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgvesselID,
      errMsgcurrentPosition,
      errMsgnextArrivalPort,
      errMsgnextArrivalDate, errMsgETD = "";
      console.log($validation.vesselID, '$validation.vesselID')
    if ($validation.vesselID.error.reason !== undefined) {
      errMsgvesselID = $validation.vesselID.show && <span className="error">{$validation.vesselID.error.reason}</span>;
    }
    if ($validation.currentPosition.error.reason !== undefined) {
      errMsgcurrentPosition = $validation.currentPosition.show && <span className="error">{$validation.currentPosition.error.reason}</span>;
    }
    if ($validation.nextArrivalPort.error.reason !== undefined) {
      errMsgnextArrivalPort = $validation.nextArrivalPort.show && <span className="error">{$validation.nextArrivalPort.error.reason}</span>;
    }
    if ($validation.nextArrivalDate.error.reason !== undefined) {
      errMsgnextArrivalDate = $validation.nextArrivalDate.show && <span className="error">{$validation.nextArrivalDate.error.reason}</span>;
    }
    if ($validation.ETD.error.reason !== undefined) {
      errMsgETD = $validation.ETD.show && <span className="error">{$validation.ETD.error.reason}</span>;
    }
    
    const currentPosition__ = fields.currentPosition?.value || ''; 
    return (
      <div>
        <button class="btn btn-secondary bg-secondary-gradient mt-3" data-bs-toggle="modal" data-bs-target="#extralargemodal" id="viewPerticular" style={{ display: "none" }}>
          Extralarge Modal
        </button>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Vessel<span className="lbl-error">*</span>
              </label>
              {console.log(errMsgvesselID, 'errMsgvesselIDerrMsgvesselID')}
              <Select value={fields.vesselID} onChange={this.handleSelectChange.bind(this, "vesselID")} placeholder="Select Vessel" isClearable={true} options={this.props.vessleList} />
              {errMsgvesselID}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Current Position<span className="lbl-error">*</span>
              </label>
               <Select
                value={fields.currentPosition}
                onChange={this.handleSelectChange.bind(this, "currentPosition")}
                placeholder="Select Current Position"
                isClearable={true}
                options={[
                  {label:'AT SEA', value:'AT SEA'},
                  {label:'AT PORT', value:'AT PORT'},
                  {label:'AT ANCHORAGE', value:'AT ANCHORAGE'},
                  {label:'AT DRYDOCK', value:'AT DRYDOCK'},
                  {label:'DRIFTING', value:'DRIFTING'}                  
                ]}
              />
              {errMsgcurrentPosition}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Next Arrival Port{currentPosition__==='AT SEA' &&<span className="lbl-error">*</span>}
              </label>
              <Select
                value={fields.nextArrivalPort}
                onChange={this.handleSelectChange.bind(this, "nextArrivalPort")}
                placeholder="Select Next Arrival Port"
                isClearable={true}
                options={this.props.portList}
              />
              {errMsgnextArrivalPort}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Next Arrival Date{currentPosition__==='AT SEA' &&<span className="lbl-error">*</span>}
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select Next Arrival Date"
                className="form-control"
                onKeyDown={(e) => e.preventDefault()}
                selected={fields.nextArrivalDate}
                dateFormat="dd-MM-yyyy"
                isClearable={fields.nextArrivalDate!==""?true:false}
                onChange={this.handleSelectChange.bind(this, "nextArrivalDate")}
              />
              {errMsgnextArrivalDate}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                ETD<span className="lbl-error">*</span>
              </label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                placeholderText="Select ETD"
                className="form-control"
                onKeyDown={(e) => e.preventDefault()}
                selected={fields.ETD}
                dateFormat="dd-MM-yyyy"
                isClearable={fields.ETD!==""?true:false}
                onChange={this.handleSelectChange.bind(this, "ETD")}
              />
              {errMsgETD}
            </div>
            
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
